module.exports = __webpack_public_path__ + "img/post-bg.b78ad7c5.jpg";